document.addEventListener("DOMContentLoaded", function () {

  const modal = document.getElementById("ShareCartModal");
  if (!modal) return;

  const EMAIL_ENDPOINT = "https://share-cart-api.onrender.com/share-cart";
  const SHARE_CART_KEY = "SHARE_CART_V1";

  // --------------------
  // OPEN / CLOSE MODAL
  // --------------------
  document.addEventListener("click", (e) => {
    if (e.target.closest("[data-share-cart]")) {
      modal.hidden = false;
    }

    if (e.target.closest("[data-share-close]")) {
      modal.hidden = true;
    }
  });

  // --------------------
  // TAB SWITCHING
  // --------------------
  modal.querySelectorAll(".share-cart-tab").forEach((tab) => {
    tab.addEventListener("click", () => {
      modal.querySelectorAll(".share-cart-tab").forEach(t =>
        t.classList.remove("active")
      );
      modal.querySelectorAll(".share-cart-form").forEach(f =>
        f.classList.remove("active")
      );

      tab.classList.add("active");
      const targetForm = modal.querySelector(
        `[data-form="${tab.dataset.tab}"]`
      );
      if (targetForm) targetForm.classList.add("active");
    });
  });

  // --------------------
  // CART PERMALINK
  // --------------------
  async function getCartPermalink() {
    try {
      const res = await fetch("/cart.js");
      const cart = await res.json();

      if (!cart.items.length) return null;

      return `${location.origin}/cart/${cart.items
        .map(i => `${i.variant_id}:${i.quantity}`)
        .join(",")}`;
    } catch (err) {
      console.error("Cart fetch error:", err);
      return null;
    }
  }

  // --------------------
  // EMAIL FORM SUBMIT
  // --------------------
  const emailForm = modal.querySelector('[data-form="email"]');

  if (emailForm) {
    emailForm.addEventListener("submit", async (e) => {
      e.preventDefault();

      const submitBtn = emailForm.querySelector('[type="submit"]');
      const originalText = submitBtn?.textContent;

      if (submitBtn) {
        submitBtn.textContent = "Sending...";
        submitBtn.disabled = true;
      }

      try {
        const cartUrl = await getCartPermalink();
        if (!cartUrl) {
          alert("Cart is empty");
          if (submitBtn) {
            submitBtn.textContent = originalText;
            submitBtn.disabled = false;
          }
          return;
        }

        const formData = new FormData(emailForm);
        formData.append("cartUrl", cartUrl);
        formData.append("key", SHARE_CART_KEY);

        const iframe = document.createElement("iframe");
        iframe.name = "share-cart-frame";
        iframe.style.display = "none";
        document.body.appendChild(iframe);

        const tempForm = document.createElement("form");
        tempForm.method = "POST";
        tempForm.action = EMAIL_ENDPOINT;
        tempForm.target = "share-cart-frame";

        for (let [key, value] of formData.entries()) {
          const input = document.createElement("input");
          input.type = "hidden";
          input.name = key;
          input.value = value;
          tempForm.appendChild(input);
        }

        document.body.appendChild(tempForm);
        tempForm.submit();

        setTimeout(() => {
          alert("Cart shared successfully ✓");
          modal.hidden = true;
          emailForm.reset();
          document.body.removeChild(tempForm);
          document.body.removeChild(iframe);

          if (submitBtn) {
            submitBtn.textContent = originalText;
            submitBtn.disabled = false;
          }
        }, 2000);

      } catch (err) {
        console.error("Email error:", err);
        alert("Failed to send email.");

        if (submitBtn) {
          submitBtn.textContent = originalText;
          submitBtn.disabled = false;
        }
      }
    });
  }

  // --------------------
  // WHATSAPP FORM
  // --------------------
  const whatsappForm = modal.querySelector('[data-form="whatsapp"]');

  if (whatsappForm) {
    whatsappForm.addEventListener("submit", async (e) => {
      e.preventDefault();

      try {
        const cartUrl = await getCartPermalink();
        if (!cartUrl) {
          alert("Cart is empty");
          return;
        }

        const data = Object.fromEntries(new FormData(whatsappForm));

        const text = encodeURIComponent(
          `Hi, this is ${data.fromName}. I wanted to share my bag with you:\n${cartUrl}`
        );

        const waLink = `https://wa.me/${data.phone}?text=${text}`;

        // Notify backend (non-blocking)
fetch(EMAIL_ENDPOINT, {
  method: "POST",
  headers: { "Content-Type": "application/json" },
  body: JSON.stringify({
    channel: "whatsapp",
    senderName: data.fromName,
    senderPhone: data.senderPhone,
    recipientPhone: data.phone,
    purchaseIntent: data.purchaseIntent,
    cartUrl: cartUrl,
    key: SHARE_CART_KEY
  })
})
.catch((err) => {
          console.error("WhatsApp logging failed:", err);
        });

        // Open WhatsApp immediately
        window.open(waLink, "_blank");

      } catch (err) {
        console.error("WhatsApp error:", err);
        alert("Something went wrong. Please try again.");
      }
    });
  }

});
